import { tv } from '~/utils/tv'
export const TagLabelVariants = tv({
  base: `
    h-extrasmall font-semibold text-threepulse font-rdmodern
    leading-medium text-center whitespace-nowrap truncate
  `,
  variants: {
    variants: {
      onSale: 'text-labelling-text-onsale',
      principal: 'text-labelling-text-principal',
      secondary: 'text-labelling-text-secondary',
      clubeRaia: 'text-labelling-text-clube',
      clubeDrogasil: 'text-labelling-text-clube',
      assinatura: 'text-labelling-text-assinatura',
      medicamentoGeladeira: 'text-labelling-text-refrigerate',
      receitaObrigatoria: 'text-labelling-text-prescription',
      generico: 'text-labelling-text-generico',
      referencia: 'text-labelling-text-referencia',
      similar: 'text-labelling-text-similar',
      stix: 'text-labelling-text-stix',
    },
  },
})
